// @ts-nocheck
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";

// Use the same interface as the table data
interface UserWithSubscription {
  id: string;
  email: string;
  name: string | null;
  role: string;
  user_id: string;
  subscriber_id?: string | null;
  is_subscribed: boolean;
  source: string;
  subscription_created_at?: string | null;
}

interface EditSubscriberModalProps {
  subscriber: UserWithSubscription;
  open: boolean;
  onClose: () => void;
  onSave: (updates: Partial<UserWithSubscription>) => void;
}

const EditSubscriberModal: React.FC<EditSubscriberModalProps> = ({
  subscriber,
  open,
  onClose,
  onSave
}) => {
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    role: "",
    is_subscribed: true,
    source: "manual" as "manual" | "signup" | "import"
  });

  useEffect(() => {
    if (subscriber && open) {
      console.log("➡️ Modal received subscriber:", subscriber);
      setFormData({
        email: subscriber.email || "",
        name: subscriber.name || "",
        role: subscriber.role || "",
        is_subscribed: subscriber.is_subscribed ?? true,
        source: (subscriber.source as "manual" | "signup" | "import") || "manual"
      });
    }
  }, [subscriber, open]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Edit Subscriber</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email *</Label>
            <Input
              id="email"
              type="email"
              required
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="name">Name</Label>
            <Input
              id="name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="role">Role</Label>
            <Select
              value={formData.role}
              onValueChange={(value) =>
                setFormData({ ...formData, role: value })
              }
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="athlete">Athlete</SelectItem>
                <SelectItem value="parent">Parent</SelectItem>
                <SelectItem value="college_coach">College Coach</SelectItem>
                
                <SelectItem value="club_coach">Club Coach</SelectItem>
                <SelectItem value="press">Press</SelectItem>
                <SelectItem value="vendor">Vendor</SelectItem>
                <SelectItem value="admin">Admin</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="source">Source</Label>
            <Select
              value={formData.source}
              onValueChange={(value: "manual" | "signup" | "import") =>
                setFormData({ ...formData, source: value })
              }
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="manual">Manual</SelectItem>
                <SelectItem value="signup">Signup</SelectItem>
                <SelectItem value="import">Import</SelectItem>
                <SelectItem value="profile">Profile</SelectItem>
                <SelectItem value="admin">Admin</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center space-x-2">
            <Switch
              id="is_subscribed"
              checked={formData.is_subscribed}
              onCheckedChange={(checked) =>
                setFormData({ ...formData, is_subscribed: checked })
              }
            />
            <Label htmlFor="is_subscribed">Subscribed</Label>
          </div>

          <div className="flex justify-end space-x-2 pt-4">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit">Save Changes</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditSubscriberModal;
